import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import {
  DELETE_PROFILE_REDUCER_NAME,
  PROFILES_LIST_REDUCER_NAME,
} from 'features/profiles/consts'
import { deleteProfile, fetchProfiles } from 'features/profiles/api'

const profilesListSlice = makeFetchSlice(PROFILES_LIST_REDUCER_NAME)
export const profilesListReducer = profilesListSlice.reducer
export const profilesListActions = profilesListSlice.actions

export const fetchProfilesListThunk = (domainId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: profilesListActions,
        asyncFunc: () => fetchProfiles(domainId),
      })
    } catch (error) {
      console.log('Error fetching profiles', error)
    }
  }
}

const deleteProfileSlice = makeFetchSlice(DELETE_PROFILE_REDUCER_NAME)
export const deleteProfileReducer = deleteProfileSlice.reducer
export const deleteProfileActions = deleteProfileSlice.actions

export const deleteProfileThunk = (rootDomainId: string, id: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: deleteProfileActions,
        asyncFunc: () => deleteProfile(id),
      })

      dispatch(fetchProfilesListThunk(rootDomainId))
    } catch (error) {
      console.log(`Error deleting Profile with id: ${id}`, error)
    }
  }
}
